// extracted by mini-css-extract-plugin
export default {"button":"ZJwu2","red":"_jUEW"};